// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3qKYg","label":"Completed_label__5pVtb"};